import React, { useEffect, useState } from "react";
import { MdOutlineDashboard } from "react-icons/md";

import RightPage from "./RightPage";
import SideBarButton from "./Components/SIdeBarButton";
import axios from "axios";
import bank1 from "../../../images/bank1.png";
import NoDataFound from "../../../components/NoDataFound";
import ImageLoading from "../../../components/ImageLoading";

function BSA({ id }) {
  const [noData, setNoData] = useState(false);
  const [loading, setLoading] = useState(false);
  const [dashBoardState, setDashBoardState] = useState("lending");
  const [selectedData, setSelectedData] = useState(null);
  const [banks, setBanks] = useState([]);
  const [bankName, setBankName] = useState("");
  const [image, setImage] = useState("");
  const mapData = (data) => {
    const array = data.map((item) => {
      return {
        title: item.bank_name,
        Icon: bank1,
        buttonItems: item.accounts.map((item) => {
          return {
            name: item.account_number,
            value: item.id,
          };
        }),
      };
    });

    return array;
  };
  const fetchUserBanks = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const options = {
        url: `${process.env.REACT_APP_URL}/lender/v1/users/${id}/bank_accounts`,
        method: "GET",
        headers: { Authorization: token },
      };
      const res = await axios(options);
      if (res.data.bank_details.length > 0) {
        setBanks(mapData(res.data.bank_details));
        setSelectedData(res.data?.bank_details[0]?.accounts[0]?.id);
        setBankName(res.data?.bank_details[0]?.bank_name);
        setImage(bank1);
      } else {
        setNoData(true);
      }
    } catch (error) {
      setLoading(false);
      setBanks([]);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchUserBanks();
  }, []);

  const listButton = {
    title: "Dashboard",
    Icon: MdOutlineDashboard,
    buttonItems: [
      {
        name: "Lending",
        value: "lending",
      },
    ],
  };

  return (
    <>
      {" "}
      {noData && (
        <div className="mt-4 w-full bg-white  h-[calc(100vh-190px)] rounded-lg">
          <NoDataFound />
        </div>
      )}
      {loading && (
        <div className="w-full h-[calc(100vh-190px)] flex items-center justify-center bg-white mt-4 rounded-lg">
          <ImageLoading />
        </div>
      )}
      {!noData && !loading && (
        <div className=" mt-4 w-full overflow-auto h-[calc(100vh-190px)] flex">
          <div className=" w-[220px] bg-white border border-[#e6ebed] rounded h-[calc(100vh-190px)] p-3">
            <SideBarButton
              buttonItem={listButton}
              dashBoardState={dashBoardState}
              setDashBoardState={setDashBoardState}
              first={true}
            />
            {banks.map((item, index) => (
              <SideBarButton
                buttonItem={item}
                dashBoardState={selectedData}
                setDashBoardState={setSelectedData}
                truncate={true}
                setBankName={setBankName}
                setImage={setImage}
              />
            ))}
          </div>
          <RightPage bank={selectedData} id={id} bankName={bankName} />
        </div>
      )}
    </>
  );
}

export default BSA;
